import { ReactNode, useMemo } from "react";
// import { CssBaseline } from "@mui/material";
import { createTheme, ThemeOptions, ThemeProvider as MUIThemeProvider } from "@mui/material/styles";

//
import palette from "./palette";
import typography from "./typography";
import breakpoints from "./breakpoints";
import componentsOverride from "./overrides";

import { Localization, thTH } from "@mui/material/locale";
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  locale: Localization;
};

export default function ThemeProvider({ locale = thTH, children }: Props) {
  const { i18n, t } = useTranslation("", { useSuspense: false });
  const themeOptions: ThemeOptions = useMemo(
    () => ({
      palette: palette,
      typography: typography(i18n.language),
      breakpoints,
    }),
    []
  );

  const theme = createTheme(themeOptions, locale);
  theme.components = {
    ...componentsOverride(theme),
  };

  return (
    <MUIThemeProvider theme={theme}>
      {/* <CssBaseline /> */}
      {children}
    </MUIThemeProvider>
  );
}
